import React from "react";
import "Common/api/requestInterceptor";
import "Common/api/responseInterceptor";
import AppPage, { AppPageHeader, Switcher } from "App/appPage";
import AppTemplate from "App/appTemplate";
import { SideBar } from "Areas/Sidebar";
import { routesAndPagesMap } from "Common/routingUtils";
function App(props) {
    return (React.createElement(AppTemplate, null,
        React.createElement(AppPage, { defaultHash: routesAndPagesMap.getDefaultHref(), header: React.createElement(AppPageHeader, null), body: React.createElement(Switcher, { getterName: "getPageComponent" }), sideBar: React.createElement(SideBar, null), ...props })));
}
export default App;
